import React from "react";
import CloseModal from "../../../components/Atomos/Icons/EditMode/CloseModal";

export type PhotoThumbnailProps = {
  src: string;
  alt?: string;
  onClick: () => void;
  onRemove?: () => void;
};

export default function PhotoThumbnail({
  src,
  alt = "Photo",
  onClick,
  onRemove,
}: PhotoThumbnailProps) {
  const handleRemove = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemove?.();
  };

  return (
    <div className="relative aspect-square rounded-lg bg-gray-100 group transition-all duration-300 ease-in-out hover:shadow-xl hover:scale-[1.02] hover:shadow-black/20">
      <button
        type="button"
        onClick={onClick}
        className="absolute inset-0 w-full h-full"
        aria-label={alt}
      >
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className="w-full h-full object-cover rounded-lg"
          onError={(e) => {
            e.currentTarget.style.display = "none";
          }}
        />
      </button>
      {onRemove && (
        <button
          type="button"
          onClick={handleRemove}
          className="p-1 absolute -top-3 -right-3 w-7 h-7 rounded-full bg-[#F0F0F0] text-gray-font flex items-center justify-center hover:bg-black/90 transition-colors text-sm font-bold z-10 shadow-md"
          aria-label="Remove photo"
        >
          <CloseModal />
        </button>
      )}
    </div>
  );
}
